import { css } from "@compiled/react";

import { TwitterComponent } from "@/templates/agile-hub/types";

export type TwitterTextComponentProps = Omit<TwitterComponent, "__typename">;

export const TwitterTextComponent = (data: TwitterTextComponentProps) => {
    const iconWrapperCss = css({
        display: "block",
        width: "30px",
        height: "30px",
        marginInlineEnd: "27.727px", // 30px - slight adjustment for actual icon size
        background:
            'no-repeat center center url("https://wac-cdn.atlassian.com/assets/img/icons/twitter.svg")',
        content: "",
        backgroundPosition: "left",
        backgroundSize: "contain"
    });

    const flexContainerCss = css({
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        flexDirection: "row",
        flex: "1 1 auto"
    });

    const textContainerCss = css({
        display: "block",
        width: "100%",
        borderInlineStart: "2px solid #172b4d",
        padding: "2px 0 2px 30px"
    });

    const tweetTextCss = css({
        "marginBlockStart": "auto",
        "marginBlockEnd": "auto",
        "fontSize": "1.5rem",
        "lineHeight": "1.2",
        "textDecoration": "underline",
        "color": "#0052cc",
        "&:hover": {
            color: "#0065ff",
            textDecoration: "none"
        }
    });

    const localizedUrl = data.tweetText
        ? encodeURI("https://twitter.com/intent/tweet?text=" + data.tweetText)
        : "";

    return (
        <div css={flexContainerCss}>
            <div css={iconWrapperCss} />
            <div css={textContainerCss}>
                <a
                    css={tweetTextCss}
                    href={localizedUrl}
                    data-event="clicked"
                    data-event-component="linkButton"
                    data-event-container="panel"
                    data-product-key="jiraSoftware"
                >
                    {data.tweetText ?? ""}
                </a>
            </div>
        </div>
    );
};
